"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IPFunctions = void 0;
/**
 * IPv4 helper functions class.
 */
class IPFunctions {
    constructor() { }
    static isValidIPv4(ipString) {
        if (!this.RE_IPV4_BASE.test(ipString)) {
            return false;
        }
        const ipParts = ipString.split(".");
        for (const ipPart of ipParts) {
            const ipPartInt = parseInt(ipPart);
            if (ipPartInt === NaN || ipPartInt < 0 || ipPartInt > 255) {
                return false;
            }
        }
        return true;
    }
    static getNumericalIP(ip) {
        const parts = ip.split(".");
        let result = 0;
        for (let i = 0; i < 4; i++) {
            result = (result | (parseInt(parts[i]) << ((3 - i) * 8))) >>> 0;
        }
        return result;
    }
    static getStringIP(ip) {
        const result = [0, 0, 0, 0];
        for (let i = 0; i < 4; i++) {
            const shift = ((3 - i) * 8);
            result[i] = (ip & (0xFF << shift)) >>> shift;
        }
        return result.join(".");
    }
    static getIPNetworkFromString(cidrIpNetworkString) {
        if (!cidrIpNetworkString || !cidrIpNetworkString.length || cidrIpNetworkString.length === 0) {
            throw new Error("Invalid IP network");
        }
        const cidrIpNetworkArray = cidrIpNetworkString.split("/");
        if (cidrIpNetworkArray.length != 2) {
            throw new Error("Invalid IP network");
        }
        const ip = cidrIpNetworkArray[0];
        if (!this.isValidIPv4(ip)) {
            throw new Error("Invalid IP network");
        }
        const prefix = parseInt(cidrIpNetworkArray[1]);
        if (isNaN(prefix)) {
            throw new Error("Invalid IP network");
        }
        if (prefix < 1 || prefix > 32) {
            throw new RangeError("IP prefix must be between 1 and 32.");
        }
        const ipNetwork = {
            ip: ip,
            prefix: prefix
        };
        return ipNetwork;
    }
    static getStringFromIPNetwork(ipNetwork) {
        if (!ipNetwork || !ipNetwork.ip || !ipNetwork.prefix) {
            throw new Error("Invalid IP network");
        }
        return ipNetwork.ip + "/" + ipNetwork.prefix;
    }
    static getSubnetMask(prefix) {
        return (0xFFFFFFFF << (32 - prefix)) >>> 0;
    }
    static getPrefix(subnetMask) {
        let prefix = 0;
        do {
            subnetMask = (subnetMask << 1) >>> 0;
            prefix++;
        } while (((subnetMask & 0x80000000) >>> 0) !== 0);
        return prefix;
    }
    static getCleanNetworkAddress(ip, subnetMask) {
        return (ip & subnetMask) >>> 0;
    }
    static getFirstAddress(ipNetwork) {
        const subnetMask = this.getSubnetMask(ipNetwork.prefix);
        const networkIP = this.getCleanNetworkAddress(this.getNumericalIP(ipNetwork.ip), subnetMask);
        // If ipNetwork.prefix == 32, the only host address is the net address.
        // If ipNetwork.prefix == 31, the first host address is the net address.
        // If ipNetwork.prefix <= 30, the first host address is the IP address after the net address.
        let ipFirst = networkIP;
        if (ipNetwork.prefix <= 30) {
            ipFirst++;
        }
        return ipFirst;
    }
    static getLastAddress(ipNetwork) {
        const subnetMask = this.getSubnetMask(ipNetwork.prefix);
        const networkIP = this.getCleanNetworkAddress(this.getNumericalIP(ipNetwork.ip), subnetMask);
        const subnetMaskInverted = (~subnetMask) >>> 0;
        // If ipNetwork.prefix == 32, the only host address is the net address.
        // If ipNetwork.prefix == 31, the last host address is the last address in the address space.
        // If ipNetwork.prefix <= 30, the last host address is the IP address before the last address
        // in the address space (which is the broadcast address).
        let ipLast = (networkIP | subnetMaskInverted) >>> 0;
        if (ipNetwork.prefix <= 30) {
            ipLast--;
        }
        return ipLast;
    }
}
exports.IPFunctions = IPFunctions;
IPFunctions.RE_IPV4_BASE = /^[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}$/;
//# sourceMappingURL=IPFunctions.js.map